import QuestionBankReducer from "./questionBank/reducer";
import AssessmentsReducer from "./assessments/reducer";
import ResultsReducer from "./results/reducer";

export { QuestionBankReducer, AssessmentsReducer, ResultsReducer };
